const ui = (state) => state.ui;

export default ui;

